<script>
export default {
  // Props: Status, Icone, Cor da Mensagem, Cor do componente, Cor do Icone, tamanho do componente
  props: {
    status: {
      type: String,
      default: 'warning',
      validator: (val) => {
        return [
          'warning',
          'error',
          'success',
          'info',
          'success_v2',
          'error_v2',
          'warning_v2',
          'info_v2',
          'warning_v3',
          'error_v3',
          'none',
        ].includes(val)
      },
    },
    center: {
      type: Boolean,
      default: false,
    },
    iconRecept: {
      type: String,
      default: '',
    },
    mensageColor: {
      type: String,
      default: '#FFFFFF',
    },
    backgroundContent: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '#FFFFFF',
    },
    size: {
      type: String,
      default: 'medium',
      validator: (val) => {
        return ['small', 'medium', 'large'].includes(val)
      },
    },
  },
  data() {
    return {
      isVisible: true,
      fadeOut: false,
    }
  },
  computed: {
    icon() {
      const icons = {
        warning: 'mdi-information-outline',
        error: 'mdi-alert',
        success: 'mdi-check-circle-outline',
        info: '',
        warning_v3: 'warning',
        error_v3: 'mdi-close-circle',
      }

      return icons[this.status] || 'mdi-alert'
    },

    colorIcon() {
      const colorIcons = {
        warning: 'yellow',
        error: 'red',
        success: 'green',
        info: '',
        warning_v3: '#BA9309',
        error_v3: '#EB5757',
      }

      return colorIcons[this.status] || this.iconColor
    },

    backgroundMessage() {
      const backgroundMessages = {
        none: 'gray',
        warning_v2: '#030309',
        error_v2: '#EB5757',
        success_v2: '#56AF79',
        info_v2: '#E4E4E4',
        warning_v3: '#F1F1F1',
        error_v3: '#F1F1F1',
      }

      return backgroundMessages[this.status]
    },

    estilos() {
      return {
        backgroundColor: this.backgroundContent || this.backgroundMessage,
        borderRadius: '8px',
        padding: this.size === 'large' ? '16px' : '8px 16px',
        color: this.mensageColor,
        transition: 'opacity 0.3s',
        opacity: this.fadeOut ? '0' : '1',
      }
    },
  },
  created() {
    this.isVisible = true
  },
  methods: {
    removeAlert() {
      this.fadeOut = true
      setTimeout(() => {
        this.isVisible = false
      }, 300)
    },
  },
}
</script>

<template>
  <div
    v-if="isVisible"
    class="d-flex rounded-xxs"
    :class="{
      'bg-danger': status === 'error',
      'bg-success': status === 'success',
      'bg-warning': status === 'warning',
      'align-items-center': center,
    }"
    :style="estilos"
    style="position: relative;"
    v-bind="$attrs"
  >
    <div class="d-flex align-items-center container-icon" style="width: 100%">
      <span
        :style="{
          position: 'absolute',
          left: '0',
          height: '40px',
          width: '2px',
          backgroundColor: colorIcon,
        }"
      />
      <icon-svg
        :name="iconRecept || icon"
        :color="colorIcon"
        :class="status.includes('error_v3') && 'icon-error_v3'"
        :size="status.includes('warning_v3') ? 40 : 24"
      />

      <div
        :class="status.includes('v3') ? 'mx-5 text-black' : 'ml-1/2rem'"
        style="width: 100%; font-size: 0.875rem; color: #4B4B4BEE"
      >
        <slot />
      </div>
      <v-spacer />
      <slot name="button" />
      <button v-if="status.includes('v3')" @click="removeAlert">
        <icon-svg name="mdi-close-circle" color="secondary" size="24" />
      </button>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.icon-error_v3
  background-color: #eb575744
  border-radius: 9999px
  width: 52px !important
  height: 42px !important
</style>
